import React from "react";
import { Box, Typography, Grid, Paper, Container } from "@mui/material";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import VerifiedIcon from "@mui/icons-material/Verified";
import { motion } from "framer-motion";
import { useAppConfig } from "../../context/AppConfigContext";

const iconMap = {
  verified: <VerifiedIcon sx={{ color: "#FF6F61" }} />,
  favoriteBorder: <FavoriteBorderIcon sx={{ color: "#FF6F61" }} />,
  emojiEvents: <EmojiEventsIcon sx={{ color: "#FF6F61" }} />,
};

const WhyChooseUs = () => {
  const { config } = useAppConfig();
  const reasons = config?.landingPage?.whyChooseUsCards || [];

  return (
    <Box sx={{ py: { xs: 8, md: 12 }, backgroundColor: "#FFF9F8" }}>
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          fontWeight="bold"
          textAlign="center"
          gutterBottom
          sx={{ fontFamily: "Moul", mb: 6 }}>
          Why People Come Back
        </Typography>

        <Grid container spacing={{ xs: 4, md: 6 }} justifyContent="center">
          {reasons.map((reason, index) => (
            <Grid item xs={12} md={4} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.2 }}>
                <Paper
                  elevation={0}
                  sx={{
                    p: { xs: 4, md: 5 },
                    borderRadius: 5,
                    textAlign: "center",
                    boxShadow: "0px 6px 20px rgba(0,0,0,0.06)",
                    backgroundColor: "white",
                    minHeight: 200,
                  }}>
                  <Box
                    sx={{
                      width: 60,
                      height: 60,
                      borderRadius: "50%",
                      backgroundColor: "#FFF1EE",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mx: "auto",
                      mb: 3,
                    }}>
                    {iconMap[reason.icon] ?? null}
                  </Box>

                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    gutterBottom
                    sx={{
                      color: "#333",
                      mb: 1,
                      fontSize: { xs: "1.125rem", md: "1.2rem" },
                      whiteSpace: "nowrap", // prevent wrapping
                    }}>
                    {reason.title}
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      color: "#606060",
                      lineHeight: 1.7,
                      fontSize: "1rem",
                    }}>
                    {reason.description}
                  </Typography>
                </Paper>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default WhyChooseUs;
